import React from 'react';
import { motion } from 'framer-motion';
export function TrapSection() {
  const oneLiners = ['"Dios no te está castigando. Te está reubicando."', '"El silencio de Dios no es ausencia. Es preparación."', '"No estás roto. Estás siendo vaciado para ser llenado."', '"El dolor que hoy no entiendes, mañana será tu mayor credencial."', '"Deja de pedirle a Dios que te devuelva lo que Él mismo quitó."', '"Tu crisis no es el final del capítulo. Es el inicio del libro real."', '"Lo que te quitaron era demasiado pequeño para tu siguiente nivel."', '"El desierto no es tu tumba. Es tu escuela."', '"Dios no rompe lo que no piensa usar."', '"Eres el elegido. Y el proceso de los elegidos siempre duele primero."'];
  return <section className="py-12 px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-395">
      <div className="max-w-[680px] mx-auto" data-id="element-396">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-397">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase text-center mb-6" data-id="element-398">
            Verdades que necesitas recordar
          </p>
          <div className="grid gap-3" data-id="element-399">
            {oneLiners.map((line, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.07
          }} className="bg-[var(--bg-card)] rounded-lg p-4 border-l-2 border-[var(--accent)] shadow-sm" data-id="element-400">
                <p className="text-[var(--text-primary)] font-serif italic text-base leading-relaxed" data-id="element-401">
                  {line}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}